import { type FC, type ReactElement, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";

import { renderSampleParentAttributesWidgets } from "@/app-utils/attributes-widgets.tsx";
import { useURLViewID } from "@/app-utils/hooks/useUrl.ts";
import { type InputTableQuerySpec } from "@/graphql.ts";
import { type IParentState } from "@/redux/modules/parent.ts";
import { type IAppState } from "@/redux/reducer.ts";
import { DATATABLE_ID_TYPE, ENTITY_TYPE } from "@/settings/settings.js";

import GenericDataTableContainer from "../core/grid/GenericDataTableContainer.js";
import { AttributesListWidget } from "../core/navigation-panel/AttributeWidget.js";
import { ChildEntitiesButtonHeader } from "../core/navigation-panel/ButtonHeaderHoc.js";

const ParentSamplesView: FC = () => {
  const viewId = useURLViewID();
  const { parentId } = useParams<"parentId">();
  const { parent } = useSelector<IAppState, IParentState>((state) => state.parent);
  const [tableSpec, setTableSpec] = useState<InputTableQuerySpec>();

  useEffect(() => {
    if (parentId) {
      setTableSpec({
        id: parentId,
        idType: DATATABLE_ID_TYPE.ENTITY,
        queryType: ENTITY_TYPE.SAMPLE_PARENT,
        resultType: ENTITY_TYPE.SAMPLE,
        pagination: undefined,
        restrictions: undefined,
        resultSubTypeId: undefined,
        rowFilter: "",
        rowSorting: "",
      });
    }
  }, [parentId]);

  const btnMenu: ReactElement = (
    <ChildEntitiesButtonHeader tableSpec={tableSpec} getParentEntityName={() => parent?.name} hideAnalyzeBtn={true} />
  );

  return (
    <GenericDataTableContainer
      tableSpec={tableSpec}
      rightToolbarElement={btnMenu}
      viewId={viewId}
      headerAttributes={[
        <AttributesListWidget
          attributes={renderSampleParentAttributesWidgets(parent)}
          key={"gene-expression-view-widget-1"}
        />,
      ]}
      title={parent?.name ?? ""}
      project={parent?.project}
      subtitle={"List of Samples"}
      noRowsText={"There are no samples available for this sample parent"}
    />
  );
};

export default ParentSamplesView;
